import { ApiProvider, BASE_API_URLS } from '@app/core/api';

import { IAddCounterPartyContact } from '../types';

export const addCounterPartyContactRequest = async ({ data }: IAddCounterPartyContact) =>
  ApiProvider.apiRequest(`${BASE_API_URLS.onboarding}/api/v1.2/Contacts/AddCounterPartyContact`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
